import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { NextRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import classNames from 'classnames';
import { Auth } from 'aws-amplify';
import Typography from './Typography';
import { colors } from '../config/color';
import { getLineHeight as h } from '../utils/getLineHeight';
import Button from './Buttons/Button';

interface Props {
  router: NextRouter;
}

const AccountExistsDialog = ({ router }: Props) => {
  const { t } = useTranslation('common');
  const classes = useStyles();

  const [open, setOpen] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const login = async () => {
    setIsSubmitting(true);
    await router.replace((router.query.redirectUrl || '') as string);
    setOpen(false);
  };

  const cancel = async () => {
    setIsSubmitting(true);
    sessionStorage.setItem('preSignOutPath', `/signup_and_purchase?redirectUrl=${router.query.redirectUrl || ''}`);
    await Auth.signOut({ global: true });
    setOpen(false);
  };

  return (
    <Dialog open={open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogContent className={classes.dialog}>
        <Typography fontFamily="Oswald" fontWeight={500} fontSize={32} color={colors.black} lineHeight={h(40)}>
          {t('login.accountExistsTitle')}
        </Typography>

        <Typography color={colors.black} fontSize={16} lineHeight={h(24)}>
          {t('login.accountExists')}
        </Typography>
      </DialogContent>

      <DialogActions className={classNames([classes.dialogActions, 'mt-4', 'mb-8'])}>
        <Button
          outlined={true}
          title={t('general.cancel')}
          onClick={cancel}
          disabled={isSubmitting}
          loading={isSubmitting}
        />
        <Button
          outlined={false}
          title={t('login.text')}
          onClick={login}
          disabled={isSubmitting}
          loading={isSubmitting}
        />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles({
  dialog: {
    maxWidth: '560px',
    textAlign: 'center',
  },
  dialogActions: {
    justifyContent: 'center',
  },
});

export default AccountExistsDialog;
